import { showComponentPopup } from '@/utils/componentPopup'
import type { ComponentPopupController } from '@/utils/componentPopup'
import { useSupportLanguages } from '@/composables/useSupportLanguages'
import LanguageSwitchPopup from './LanguageSwitchPopup.vue'

export const showLanguageSwitchPopup = async () => {
  const { initLanguages, visibleLangList, isMultiLangEnabled } = useSupportLanguages()
  await initLanguages()

  if (!isMultiLangEnabled.value || visibleLangList.value.length <= 1) {
    return
  }

  let popupController: ComponentPopupController | null = null

  popupController = showComponentPopup(LanguageSwitchPopup, {
    props: {
      onClose: () => {
        popupController?.close()
      }
    },
    popupProps: {}
  })
}

export default LanguageSwitchPopup
